export default __webpack_public_path__ + "static/media/beauty_2020_OV_seemore_EH-NA98-K_6_201127.1040fe1c.jpg";